import showdown from 'showdown';
import { useRouter } from 'next/router';

import './CoursesInsuranceCompensation.scss';
import icons from '../../shared/assets/icons/redesign';
import sendEvent, { usePlatform } from '../../helpers/tracking';
import { calculateCoursesMemberCount } from '../CoursesIntro/CoursesIntro.jsx';

const { Check, Logo, SadSmile } = icons;

const converter = new showdown.Converter();

export default function CoursesInsuranceCompensation({
  insurer,
  addUserEvent,
  insurerPolicy
}) {
  const router = useRouter();
  const platform = usePlatform();

  return (
    <div className="componentWrap">
      <div className="coursesInsuranceCompensation-header">
        <Logo />

        <span
          className="coursesInsuranceCompensation-close-icon"
          onClick={() => (location.href = '/verzekering/cursus-vergoeding')}
        >
          &times;
        </span>
      </div>

      <Content
        router={router}
        insurer={insurer}
        platform={platform}
        addUserEvent={addUserEvent}
        insurerPolicy={insurerPolicy}
      />
    </div>
  );
}

function Content({ insurer, insurerPolicy, router, addUserEvent, platform }) {
  if (
    !insurer.compensation ||
    (insurer.compensation && !insurerPolicy.coversCourses)
  )
    return (
      <>
        <div className="coursesInsuranceCompensation-icon-wrap">
          <SadSmile />
        </div>

        <div className="coursesInsuranceCompensation-text">
          Helaas, volgens onze gegevens vergoedt {insurer.displayName}{' '}
          {insurer.compensation && !insurerPolicy.coversCourses
            ? insurerPolicy?.name
            : ''}{' '}
          de kosten voor het cursusportaal (nog) niet.
        </div>

        <p className="coursesInsuranceCompensation-text-small">
          Je kunt het uiteraard ook zelf betalen, onze meer dan{' '}
          {calculateCoursesMemberCount()} actieve gebruikers zijn het bewijs dat
          het je investering meer dan waard is.
        </p>

        <div className="coursesInsuranceCompensation-fixed">
          <div className="coursesInsuranceCompensation-footer-section">
            <span className="coursesInsuranceCompensation-footer-icon-wrap">
              <Check className="coursesInsuranceCompensation-footer-icon" />
            </span>
            <p className="coursesInsuranceCompensation-footer-text">
              Om de teleurstelling weg te nemen én je te motiveren om door te
              pakken, bieden we je nu een exclusieve korting aan. Kies voor het
              Plus-pakket en betaal slechts{' '}
              <span className="coursesInsuranceCompensation-footer-text-bold">
                €99,95
              </span>{' '}
              in plaats van €239,95.
            </p>
          </div>

          <button
            onClick={() => {
              addUserEvent({
                variables: { type: 'courses-buybutton-noCover', data: '{}' }
              });

              router.push('/zwangerschapscursus/welkom?dimension5=not-p34-s3');

              sendEvent(
                `courseswelkom-${platform}`,
                'courseswelkom-clickbuybutton',
                'courseswelkom-clickbuybuttoninsuranceunsuccess'
              );
            }}
            className="
              coursesInsuranceCompensation-button
              coursesInsuranceCompensation-button-primary-alternate
            "
          >
            Kopen
          </button>

          <button
            onClick={() => (location.href = '/verzekering/cursus-vergoeding')}
            className="
              coursesInsuranceCompensation-button
              coursesInsuranceCompensation-button-secondary
            "
          >
            Terug
          </button>
        </div>
      </>
    );
  else if (insurerPolicy.coversCourses)
    return (
      <div style={{ minHeight: '600px' }}>
        <div className="coursesInsuranceCompensation-icon-wrap">
          <Check className="coursesInsuranceCompensation-check-icon" />
        </div>

        <h3 className="coursesInsuranceCompensation-title">
          {insurer.displayName}'s aanvullende verzekering {insurerPolicy.name}{' '}
          vergoed de cursussen!
        </h3>

        {insurerPolicy.description && (
          <div className="coursesInsuranceCompensation-text">
            {insurerPolicy.description}
          </div>
        )}

        <p
          className="coursesInsuranceCompensation-text"
          dangerouslySetInnerHTML={{
            __html: converter.makeHtml(insurer.description)
          }}
        />

        <p className="coursesInsuranceCompensation-text-small">
          Aan de gegeven informatie kunnen geen rechten worden ontleend.
        </p>

        <div
          {...(!insurer.description && {
            className: 'coursesInsuranceCompensation-fixed'
          })}
        >
          <button
            onClick={() => (location.href = '/verzekering/cursus-vergoeding')}
            className="coursesInsuranceCompensation-button coursesInsuranceCompensation-button-secondary"
          >
            Terug
          </button>

          <button
            onClick={() => {
              addUserEvent({
                variables: { type: 'courses-buybutton', data: '{}' }
              });

              router.push('/zwangerschapscursus/welkom');

              sendEvent(
                `courseswelkom-${platform}`,
                'courseswelkom-clickbuybutton',
                'courseswelkom-clickbuybuttoninsurancesuccess'
              );
            }}
            className="
              coursesInsuranceCompensation-button
              coursesInsuranceCompensation-button-primary
            "
          >
            Kopen
          </button>
        </div>
      </div>
    );
}
